import React from 'react';

import SideDrawer from '../../../../common/components/sideDrawer/sideDrawer';
import RequisitesFormUR from '../../Request/components/RequestCard/Forms/RequisitesFormUR';
import RequisitesFormFIZ from '../../Request/components/RequestCard/Forms/RequisitesFormFIZ';
import RequisitesFormIP from '../../Request/components/RequestCard/Forms/RequisitesFormIP';

const getForm = (company, getFieldDecorator) => {
  switch (company.subjectId.subjectKey) {
    case 'legal':
      return (
        <RequisitesFormUR company={company} decorator={getFieldDecorator} />
      );
    case 'physical':
      return (
        <RequisitesFormFIZ company={company} decorator={getFieldDecorator} />
      );
    case 'individ':
      return (
        <RequisitesFormIP company={company} decorator={getFieldDecorator} />
      );
    default:
      return null;
  }
};

const DrawerRequisites = props => {
  const { visible, handleClose, form } = props;
  const company = form.getFieldValue('companyId');
  if (!company || !company.subjectId) return null;
  const RequisitesForm = getForm(company, form.getFieldDecorator);
  if (!RequisitesForm) return null;
  return (
    <SideDrawer
      header={
        <div className="title">
          <p className="main">Заказчик</p>
          <p className="sub">{company.nameLegal}</p>
        </div>
      }
      placement="left"
      width={896}
      visible={visible}
      close={handleClose}
    >
      {RequisitesForm}
    </SideDrawer>
  );
};

export default DrawerRequisites;
